// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /invite/bulk-preview.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeInviteBulkPreviewBody,
  typeInviteBulkPreviewOutput200,
} from "../../sdk/invite/postInviteBulkPreview";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildInviteBulkPreviewQueryKey(
  payload: typeInviteBulkPreviewBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`source:${JSON.stringify(payload.source)}`);
  queryKeySegments.push(`sourceId:${JSON.stringify(payload.sourceId)}`);
  return ["post:invite:inviteBulkPreview", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeInviteBulkPreviewOutput200,
    unknown,
    typeInviteBulkPreviewOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useInviteBulkPreview(
  payload: typeInviteBulkPreviewBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildInviteBulkPreviewQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postInviteBulkPreview(payload),
    ...resolvedOptions,
  });
}
